import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { routes } from "@/global/routes";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import {
  Box,
  ListItemIcon,
  MenuItem,
  Divider,
  Paper,
  Container,
  Stack,
  useTheme,
  ListItemText,
} from "@mui/material";
import { useRouter } from "next/router";
import NextImage from "next/image";
import { extractUrlParams } from "@/global/utils/utils";
import CreditCardRoundedIcon from "@mui/icons-material/CreditCardRounded";
import RedeemRoundedIcon from "@mui/icons-material/RedeemRounded";
import React from "react";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "@/shared/common/LanguageSwitcher";

export function GiftCardNavMenuItems(props: {
  hidePurchaseItem?: boolean;
  hideReedemItem?: boolean;
}) {
  const { teamSchema, languages, giftCardConfigs } = useTeamConfig();
  const router = useRouter();
  const customShareGiftUrl = giftCardConfigs?.customShareGiftUrl || routes.gift;
  const { t } = useTranslation();

  return (
    <Box>
      {!props.hidePurchaseItem ? (
        <MenuItem
          sx={{ paddingRight: "24px", mt: "8px" }}
          onClick={() =>
            router.push({
              pathname: customShareGiftUrl,
              query: {
                teamSchema,
              },
            })
          }
        >
          <ListItemIcon>
            <CreditCardRoundedIcon />
          </ListItemIcon>
          <ListItemText>
            {t("hamburgerMenu.shareGiftCardItemLabel") ||
              languages?.purchaseGiftCard?.navMenueLinkText ||
              "Share a Gift Card"}
          </ListItemText>
        </MenuItem>
      ) : null}

      {!props.hideReedemItem ? (
        <MenuItem
          sx={{ paddingRight: "24px" }}
          onClick={() =>
            router.push({
              pathname: routes.redeem,
              query: {
                teamSchema,
              },
            })
          }
        >
          <ListItemIcon>
            <RedeemRoundedIcon />
          </ListItemIcon>
          <ListItemText>
            {t("hamburgerMenu.redeemGiftCardItemLabel") ||
              languages?.redeemGiftCard?.navMenueLinkText ||
              "Redeem Gift Card"}
          </ListItemText>
        </MenuItem>
      ) : null}
      <Divider />
    </Box>
  );
}

export function GiftCardPageHeader(props: {
  renderMenu?: () => React.ReactNode;
}) {
  const theme = useTheme();
  const router = useRouter();
  const { md: mdDown } = useCssMediaQuery("down");
  const { md: mdUp } = useCssMediaQuery("up");
  const { teamSchema, defaultRoute, images } = useTeamConfig();

  const handleLogoClick = () => {
    router.push({
      pathname: defaultRoute,
      query: { teamSchema },
    });
  };

  return (
    <Paper
      id="flex-app-header"
      square={true}
      variant="outlined"
      sx={{
        borderTop: "none",
        borderLeft: "none",
        borderRight: "none",
        position: "sticky",
        top: "0",
        backgroundColor: theme.palette.common.white,
        zIndex: "999",
      }}
    >
      <Container maxWidth={"xl"}>
        <Stack
          py={2}
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          spacing={mdDown ? 1 : 3}
        >
          <Stack
            direction={"row"}
            spacing={1}
            alignItems={"center"}
            onClick={handleLogoClick}
            sx={{ cursor: "pointer" }}
          >
            {images.logoImage ? (
              <NextImage
                alt={teamSchema}
                width={extractUrlParams(images.logoImage).width}
                height={extractUrlParams(images.logoImage).height}
                src={images.logoImage}
              />
            ) : null}
          </Stack>

          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <LanguageSwitcher />
            {props?.renderMenu?.()}
          </Stack>
        </Stack>
      </Container>
    </Paper>
  );
}
